import React from "react";
import { Link } from "react-router-dom";
import SeoMeta from "../components/SeoMeta";
import { GradientDivider, WaveDivider } from "../components/UI";
import { INSTAGRAM_URL, SITE_URL } from "../constants/site";

export default function Home() {
    return (
        <>
            <SeoMeta
                title="Osprey Racing Team - Missoula Bike Racing | Race, Ride, Volunteer"
                description="Osprey Racing Team - Bike racing in Missoula, MT. Join us to race, ride, and volunteer in the cycling community."
                url={SITE_URL}
                image="/img/OspreyLogoYellow.png"
                twitterDescription="Bike racing in Missoula MT. Race, ride, volunteer."
            />
            <div className="min-h-screen bg-gray-900 text-white">
                <div className="relative h-screen flex items-center justify-center">
                    <div
                        className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
                        style={{
                            backgroundImage: "url('/img/westRace.jpeg')",
                        }}
                    />
                    <div className="absolute inset-0 z-10 bg-black/50" />
                    <div className="relative z-20 text-center px-4">
                        <img src="/img/OspreyLogoYellow.png" alt="Osprey Racing" className="h-16 w-auto mb-8" />
                        <p className="text-xl md:text-2xl mb-8 text-transparent bg-clip-text bg-gradient-to-r from-sky-400 via-yellow-400 to-sky-400 font-semibold">
                            Race. Ride. Volunteer.
                        </p>
                        <Link
                            to="/about"
                            className="bg-yellow-400 hover:bg-yellow-500 font-bold py-3 px-8 rounded-full transition duration-300"
                        >
                            <span className="bg-gradient-to-r from-gray-900 via-blue-700 to-gray-900 bg-clip-text text-transparent">
                                Meet the Team
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="flex justify-center my-8">
                    <div className="bg-gradient-to-r from-sky-400 to-blue-500 p-0.5 rounded-full inline-block hover:scale-105 transition-transform duration-200">
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center bg-gray-800 hover:bg-gray-700 text-sky-400 font-semibold py-2 px-6 rounded-full transition-colors duration-200 shadow-lg"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                className="w-6 h-6 mr-2"
                            >
                                <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5A4.25 4.25 0 0 0 20.5 16.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5zm4.25 3.25a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5zm0 1.5a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5zm5.13.87a1.13 1.13 0 1 1-2.26 0 1.13 1.13 0 0 1 2.26 0z" />
                            </svg>
                            Osprey Insta
                        </a>
                    </div>
                </div>

                <GradientDivider />
                <WaveDivider />
            </div>
        </>
    );
}
